import { api } from "@/config";

export default {
  /**
   *
   * @param {string} callbackElementId The Id of the Element to Disable if there are errors
   * @returns Object
   */
  checkInputValidity({ context }, { callbackElementId }) {
    let errors = {};
    let inputs = document.querySelectorAll("input");
    let textareas = document.querySelectorAll("textarea");
    let selects = document.querySelectorAll("select");

    ["selects", "textareas", "inputs"].map(function (selector) {
      document.querySelectorAll(selector).forEach((element) => {
        if (element.name) {
          if (element.checkValidity() || element.value != 0) {
            delete errors[element.name];
            element.classList.remove("is-invalid");
          } else {
            errors[element.name] = element.validationMessage;
            element.classList.add("is-invalid");
          }
        }
      });
    });

    let callbackElement = document.getElementById(callbackElementId);
    if (callbackElement) {
      if (Object.values(errors).length > 0) {
        callbackElement.disabled = true;
      } else {
        callbackElement.disabled = false;
      }
    }
    return errors;
  },
  // eslint-disable-next-line no-unused-vars
  async login({ commit }, { credentials }) {
    localStorage.clear();
    try {
      const response = await api.post("/login", credentials);
      // const { token, user } = response.data;
      // localStorage.setItem("token", token);
      // commit("SET_USER", user);
      return response;
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  },
  // async login({ context }, { credentials }) {
  //   localStorage.clear();
  //   return await api.post("/login", credentials);
  // },
  delete({ context }, { path, id }) {
    return api.delete(`/${path}`);
  },
  getProfile({ context }) {
    return api.get("");
  },
  updateProfile({ context }, { payload }) {
    return api.post(
      "",
      { ...payload, _method: "PATCH" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  // showOtpDialog: ({ context }, { title, description }) => {
  //   return Swal.fire({
  //     title: description,
  //     text: title,
  //     input: "text",
  //     showCancelButton: true,
  //     confirmButtonText: "Verify",
  //     showLoaderOnConfirm: true,
  //     didOpen: () => {
  //       const input = Swal.getInput();
  //       if (input) input.focus();
  //     },
  //     preConfirm: (code) => {
  //       if (!code || code.trim() === "") {
  //         Swal.showValidationMessage("Authorization Code is required!");
  //         return false;
  //       }

  //       return fetch("/api/validate-otp", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ code: code.trim() }),
  //       })
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error("Invalid response");
  //           }
  //           return response.json();
  //         })
  //         .then((data) => {
  //           if (!data.valid) {
  //             throw new Error("Invalid or expired code");
  //           }
  //           return code.trim(); // Resolve with code on success
  //         })
  //         .catch((error) => {
  //           Swal.showValidationMessage(error.message || "Validation failed");
  //         });
  //     },
  //     allowOutsideClick: () => !Swal.isLoading(),
  //   });
  // },

  showOtpDialog: ({ context }, { title, description }) => {
    return Swal.fire({
      title: description,
      text: title,
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Verify",
      showLoaderOnConfirm: true,
    });
  },
};
